import { initDialogBehavior } from './dialog.js';

const url = 'https://nokia.hoffman.com';

const initShareDialog = () => {
	const dialog = document.querySelector('.share-dialog');
	if (!dialog) return;

	const copyBtn = dialog.querySelector('.share-dialog__copy');
	const emailLink = dialog.querySelector('.share-dialog__email');
	const urlDisplay = dialog.querySelector('.share-dialog__url-display');

	const populateDialog = () => {
		urlDisplay.textContent = url;
		emailLink.href = `mailto:?subject=Hoffman%20Agency%20%E2%80%93%20Nokia%20Pitch&body=Check%20this%20out%3A%20${encodeURIComponent(url)}`;
	};

	const handleCopy = async () => {
		await navigator.clipboard.writeText(`${url}?shared=true`);
		copyBtn.textContent = copyBtn.textContent = "Copied! 👍";
		setTimeout(()=> {
			copyBtn.textContent = 'Copy Link';
		},2000);
	};

	initDialogBehavior(dialog, populateDialog);
	copyBtn?.addEventListener('click', handleCopy);
};

export { initShareDialog };
